import React, { Component } from "react";
import "../scss/index.scss";
class About extends Component {
  render() {
    return (
      <>
        <div className="app align-center">
          <h1>Github</h1>
          <h2>is how people build software.</h2>
          <h4>At this project were used technologies</h4>
          <h4>and instruments such as</h4>
          <h4>React, SCSS, Github, JS, HTML, CSS3, Visual Code, brain.</h4>
          <p>Creator: Olha Afanasieva</p>
        </div>
      </>
    );
  }
}

export default About;
